import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import filters from './plugins/filters'
import i18n from './plugins/i18n'

import Vuelidate from 'vuelidate'
import SocialSharing from 'vue-social-sharing'
import router from './router'
import store from './store'
import axios from 'axios'
import VueMq from 'vue-mq'
import messagePlagin from '@/utils/message.plagin'
import VueFilterDateFormat from 'vue-filter-date-format'
import CKEditor from '@ckeditor/ckeditor5-vue'
import moment from 'moment'
import VueNoty from 'vuejs-noty'
import VueAuthenticate from 'vue-authenticate'
import VueMeta from 'vue-meta'
import { Trans } from './plugins/Translation'
import VueYandexMetrika from 'vue-yandex-metrika'
import VueHtml2Canvas from 'vue-html2canvas';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

require('./assets/libs/ico-fonts/ewmi-icons.css')

import 'vuejs-noty/dist/vuejs-noty.css'
import 'regenerator-runtime/runtime';
Vue.component('auth-layout', () => import('@/layouts/AuthLayout'))
Vue.component('empty-layout', () => import('@/layouts/EmptyLayout'))
Vue.component('main-layout', () => import('@/layouts/MainLayout'))

Vue.use(VueMeta)
Vue.use(VueNoty)
Vue.use(SocialSharing)
Vue.use(Vuelidate)
Vue.use(messagePlagin)
Vue.use(CKEditor)
Vue.use(VueHtml2Canvas)
Vue.use(VueFilterDateFormat, {
  dayOfWeekNames: [
    'Воскресенье',
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота'
  ],
  dayOfWeekNamesNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  monthNames: [
    'Январь(-я)',
    'Февраль(-я)',
    'Март(-а)',
    'Апрель(-я)',
    'Май(-я)',
    'Июнь(-я)',
    'Июль(-я)',
    'Август(-а)',
    'Сентябрь(-я)',
    'Октябрь(-я)',
    'Ноябрь(-я)',
    'Декабрь(-я)'
  ],
  monthNamesShort: [
    'Янв',
    'Фев',
    'Мар',
    'Апр',
    'Май',
    'Июн',
    'Июл',
    'Авг',
    'Сен',
    'Окт',
    'Ноя',
    'Дек'
  ]
})
Vue.use(moment)

Vue.use(VueMq, {
  breakpoints: {
    mobile: 812,
    laptop: 2800,
    desktop: Infinity,
  }
})

Vue.use(VueAuthenticate, {
  baseUrl: process.env.VUE_APP_BACK_URL,
  tokenName: 'access_token',
  providers: {
    google: {
      clientId: '477523539170-div8jsh832vsbrgthgafompvq74p0jqf.apps.googleusercontent.com',
      redirectUri: process.env.VUE_APP_URL  + 'ru/api/public/auth/google',
      url: process.env.VUE_APP_BACK_URL + 'ru/api/public/auth/google'
    },
    facebook: {
      clientId: '247761416382857',
      // redirectUri: process.env.VUE_APP_BACK_URL  + 'ru/api/public/auth/facebook',
      url: process.env.VUE_APP_BACK_URL + 'ru/api/public/auth/facebook'
    }
  }
})

Vue.prototype.$http = axios
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common[
    'Authorization'
    ] = `Bearer ${token}`
}

axios.defaults.baseURL = process.env.VUE_APP_BACK_URL
axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.request.use(function (config) {
  if (config.url.includes('api/public')) {
    if (!config.url.includes('/api/public/user/current')
      && !config.url.includes('/api/public/cms/widget/menu_profile')
      && !config.url.includes('/api/public/search/npaCommentAnswerFormData')
      && !config.url.includes('/api/public/search/law/profile')
      && !config.url.includes('/api/public/search/lawData')
      && !config.url.includes('/api/public/search/npa')
      && !config.url.includes('/api/public/appeal/formData')
      && !config.url.includes('/api/public/siteRating/createSiteRating')) {
      delete config.headers.common.Authorization
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response.status === 401) {
      store.dispatch('logout')
    }

    return Promise.reject(error)
  }
)
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)
Vue.config.productionTip = false

Vue.use(VueYandexMetrika, {
  id: 83398558,
  env: process.env.NODE_ENV
})

new Vue({
  vuetify,
  router,
  store,
  filters,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
